module.exports = __webpack_public_path__ + "static/media/plebiscito.b6597434.webp";